import { render } from "./serves.vue?vue&type=template&id=844311c6&scoped=true"
import script from "./serves.vue?vue&type=script&lang=js"
export * from "./serves.vue?vue&type=script&lang=js"

import "./serves.vue?vue&type=style&index=0&id=844311c6&scoped=true&lang=css"

import exportComponent from "/home/kira/project/web/SPACDYNA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-844311c6"]])

export default __exports__